import { Link, Typography } from '@branchjs/neo-components';
import { cx } from '@emotion/css';
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { ImageService } from '../../../../main/services/ImageService/ImageService';
import { useStyles } from './LoggedOutContainer.styles';
import type { LoggedOutContainerProps } from './LoggedOutContainer.types';

const LoggedOutContainer = (props: LoggedOutContainerProps) => {
  const { title, linkTitle, linkText, linkPathName, children } = props;
  const classes = useStyles();

  return (
    <div className="login-form">
      <div className={classes.logoContainer}>
        <img
          className={classes.logo}
          src={ImageService.getImageUrl('/static/images/branch-logos/branch-logo_dark.svg')}
          data-testid="logo-image"
        />
      </div>
      <div className={classes.contentContainer}>
        <div>
          {title && (
            <Typography variant="h3" color="primary">
              {title}
            </Typography>
          )}
          {linkTitle && linkText && linkPathName && (
            <div className={cx(classes.linkNavigation, title && classes.titleGap)}>
              {linkTitle && (
                <Typography variant="body2" className={classes.linkNavigationTitle}>
                  {linkTitle}
                </Typography>
              )}
              {linkText && linkPathName && (
                <Link
                  to={{ pathname: linkPathName }}
                  component={ReactRouterLink}
                  id="loggedoutcontainer-title-link"
                  underline="hover"
                >
                  <Typography variant="h5" className={classes.linkNavigationText}>
                    {linkText}
                  </Typography>
                </Link>
              )}
            </div>
          )}
        </div>
        {children}
      </div>
    </div>
  );
};

export default LoggedOutContainer;
